// extracted by mini-css-extract-plugin
module.exports = {"priceQtyTable":"_1PzSP74IhNlYGGohmU-7_c","tierPriceTable":"_3pHOIb1GteipcKV6w0t8fR"};